module.exports = __webpack_public_path__ + "public/img/tower0.4bcc0b35.gif";